const _ = require('lodash');
const moment = require('moment');
const defaultState = {
    cp: [],
    cpDetail: {},
    loading: false,
    loadingHist: false,
    errors:{},
    lastFiltersCP:[],
    cpHist:[]
  }
  
export default (state=defaultState, action={}) => {
    switch (action.type) {

      case 'FETCH_CP_FULFILLED': {
        let arrayMain=[];
        let newItem = {};
        
        if(Array.isArray(action.payload.data)){
            action.payload.data.forEach((element,index) => {
            newItem = {};
            newItem = element;//limpa para criar um novo
            newItem["BEGIN_DATETIME_LOCAL"] = moment.utc(element.BEGIN_DATETIME, 'YYYY-MM-DD HH:mm').tz(element.TIMEZONE).format('YYYY-MM-DD HH:mm');
            newItem["END_DATETIME_LOCAL"] = moment.utc(element.END_DATETIME, 'YYYY-MM-DD HH:mm').tz(element.TIMEZONE).format('YYYY-MM-DD HH:mm');

            //fazer set de state destes valores como auxiliares para criar valdiações
            arrayMain.push(newItem);
            });       
        }else{
            console.log('FETCH_CP_FULFILLED error: ');
            console.dir(action.payload.data);
        }
        return {
          ...state,
          cp: arrayMain,
          loading: false,
          errors: {}
        }
      }
  
      case 'FETCH_CP_PENDING': {
        return {
          ...state,
          loading: true,
          errors: {}
        }
      }
  
      case 'FETCH_CP_REJECTED': {
        return {
          ...state,
          loading: false,
          errors: { global: action.payload.message }
        }
      }
  
      case 'FETCH_CP_DETAIL_FULFILLED': {

        const id = action.payload.data[0].ID;
        const status = action.payload.data[0].STATUS;
        const idFP = action.payload.data[0].ID_FP;

        return {
          ...state,
          cpDetail: action.payload.data[0],
          cp: state.cp.map(item => item.ID === id ? {...item, STATUS: status, ID_FP: idFP} : item),
          errors: {},
          loadingHist: false
        }
      }

      case 'FETCH_CP_DETAIL_PENDING': {
        return {
          ...state,
          loadingHist: true,
          cpDetail: {},
          errors: {}
        }
      }
      
      case 'FETCH_CP_DETAIL_REJECTED': {
        return {
          ...state,
          loadingHist: false,
          errors: { global: action.payload.message }
        }
      }      

      case 'LASTFILTER_CP': {      
        return {
          ...state,
          lastFiltersCP: action.payload
        }
      }

      case 'FETCH_CP_HISTORY_FULFILLED': {
        return {
          ...state,
          cpHist: action.payload.data,
          loadingHist: false,
          errors: {}
        }
      }
  
      case 'FETCH_CP_HISTORY_PENDING': {
        return {
          ...state,
          loadingHist: true,
          errors: {}
        }
      }
  
      case 'FETCH_CP_HISTORY_REJECTED': {
        return {
          ...state,
          loadingHist: false,
          errors: { global: action.payload.message }
        }
      }

      case 'REFRESH_CP_LIST': {      
        const id = action.payload['rejectCPId'];
        const prevStatus = action.payload['rejectCPStatus'];
        let auxDetail = _.cloneDeep(state.cpDetail);
        auxDetail['STATUS'] = prevStatus;
        return {
          ...state,
          cp: state.cp.map(item => item.ID === id ? {...item, STATUS: prevStatus} : item),
          cpDetail: auxDetail
        }
      }

      //cases de refresh do state com base em sockets emitidos pelo server
      case 'DELETE_CP_FULFILLED': {
        const id = action.id;
        return {
            ...state,
            cp: state.cp.filter(item => item.ID !== id)
        }
      }

      case 'EDIT_CP_FULFILLED': {

        const id = action.editedRecord.ID;
        const auxEditedRecord = action.editedRecord;
        return {
            ...state,
            cp: state.cp.map(item => item.ID === id 
              ? auxEditedRecord 
              : item
              )
        }
      }

      default:
        return state;
    }
  }



// WEBPACK FOOTER //
// ./src/reducers/cp-reducer.js